var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "variant-form",
        class: {
          "is-invalid": _vm.isSubmitted && _vm.error,
        },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.save.apply(null, arguments)
          },
        },
      },
      [
        _c("c-input", {
          ref: "field",
          staticClass: "variant-form__field",
          attrs: {
            autofocus: true,
            required: _vm.isSubmitted && _vm.error,
            "required-message": _vm.isSubmitted && _vm.error,
          },
          model: {
            value: _vm.tmpValue,
            callback: function ($$v) {
              _vm.tmpValue = $$v
            },
            expression: "tmpValue",
          },
        }),
        _c(
          "div",
          { staticClass: "variant-form__actions" },
          [
            _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    content: "Отменить",
                    placement: "top",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Отменить',\n          placement: 'top',\n        }",
                  modifiers: { html: true },
                },
              ],
              staticClass: "variant-form__reset",
              attrs: {
                icon: { icon: "close", color: "secondary" },
                size: "iconic",
              },
              on: { click: _vm.reset },
            }),
            _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    content: "Сохранить",
                    placement: "top",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Сохранить',\n          placement: 'top',\n        }",
                  modifiers: { html: true },
                },
              ],
              staticClass: "variant-form__save",
              attrs: {
                icon: { icon: "check", color: "success" },
                size: "iconic",
              },
              on: { click: _vm.save },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }